import {
  Box,
  CircularProgress,
  IconButton,
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { normalizeSkinUrl } from '../../utils/skinUrl';

export default function SkinsTable({
  items,
  loading,
  onEdit,
  onDelete,
  page,
  totalPages,
  onChangePage,
}) {
  return (
    <Box sx={{ border: '1px solid #eee', borderRadius: 1, bgcolor: '#fff' }}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell width={90}>Thumb</TableCell>
                <TableCell>Title</TableCell>
                <TableCell width={260}>Tags</TableCell>
                <TableCell width={110}>Premium</TableCell>
                <TableCell width={120}>Counts</TableCell>
                <TableCell width={120} align="right">
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {items.map((row) => (
                <TableRow key={row._id} hover>
                  <TableCell>
                    <img
                      src={normalizeSkinUrl(row.thumb)}
                      alt=""
                      style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 8 }}
                    />
                  </TableCell>

                  <TableCell>
                    <Typography sx={{ fontWeight: 600 }}>{row.title}</Typography>
                  </TableCell>

                  <TableCell>
                    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
                      {(row.tags || []).slice(0, 8).map((t, idx) => (
                        <Chip
                          key={`${t}-${idx}`}
                          label={t}
                          size="small"
                          variant="outlined"
                          sx={{ pointerEvents: 'none', userSelect: 'none' }}
                        />
                      ))}
                      {(row.tags || []).length > 8 && (
                        <Chip
                          label={`+${(row.tags || []).length - 8}`}
                          size="small"
                          variant="outlined"
                          sx={{ pointerEvents: 'none', userSelect: 'none' }}
                        />
                      )}
                    </Stack>
                  </TableCell>

                  <TableCell>{row.isPremium ? 'Yes' : 'No'}</TableCell>

                  <TableCell>
                    <Typography variant="caption">
                      v:{row.c_view || 0} · l:{row.c_like || 0} · d:{row.c_download || 0}
                    </Typography>
                  </TableCell>

                  <TableCell align="right">
                    <IconButton size="small" onClick={() => onEdit(row)}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" color="error" onClick={() => onDelete(row._id)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {items.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 4, color: 'text.secondary' }}>
                    No skins
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <Pagination
              page={page}
              count={Math.max(totalPages || 1, 1)}
              onChange={(_, v) => onChangePage(v)}
            />
          </Box>
        </>
      )}
    </Box>
  );
}